import { render, staticRenderFns } from "./AccionesComponente.vue?vue&type=template&id=79429242"
import script from "./AccionesComponente.vue?vue&type=script&lang=js"
export * from "./AccionesComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports